import React from 'react'
import values from 'mout/object/values'
import sortByPropText from '../../../helpers/content/manageSets/sortByPropText'
import OverviewPage from './OverviewPage'
import SkillBreakdownReport from './SkillBreakdownReport'
import TestTakingPage from './TestTakingPage'
import ThresholdPage from './ThresholdPage'
import thresholdBreaks from '../../../helpers/assessment/thresholdBreaks'
import AnswerPercentagePages from './AnswerPercentagePages'
import ScoresByStudentPage from './ScoresByStudentPage'
import StudentReportPage from './StudentReportPage'
import StudentAnswerMapPages from './StudentAnswerMapPages'
import getHeaderText from '../../../helpers/assessment/getHeaderText';
import getTestTakingData from '../../../helpers/assessment/getTestTakingData';
import getThresholdData from '../../../helpers/assessment/getThresholdData';

/*
  <AssessPrintTemplate
    score={this.props.userAssessment.scoring}
  />
*/

export default function AssessPrintTemplate ({userAssessment, nodes, isGroup, items, studentScoring, user, usersData, printStudentReports}) {
	const score = userAssessment.scoring
	const { byTest, bySubtest, byNode, byItem } = score
	let studentScores = []
	studentScoring ? studentScores = sortByPropText(values(studentScoring), 'lastName') : null
	const headerText = getHeaderText(usersData, user, userAssessment)


	let skillBreakdownReports = []
	sortByPropText(values(userAssessment.assessmentSubtests), 'index').forEach((subtest) => {
		score.bySubtest && score.bySubtest[subtest.setId] && score.bySubtest[subtest.setId].complete
		? skillBreakdownReports.push(
			<SkillBreakdownReport
				scores={score}
				subtest={subtest}
				nodes={nodes}
				maxNodeLevel={3}
				key={`skillBreakdownReport${subtest.name}`}
				headerText={headerText}
				isGroup={isGroup}
			/>
		)
		: null
	})

	const testTakingData = getTestTakingData(score, userAssessment, studentScoring)
	const thresholdData = getThresholdData(userAssessment, studentScoring)
	  
  return (
    <html>

			<head>
				<meta charSet="UTF-8" />
				<title>{`TruScore ${userAssessment.assessmentSet.displayName} | ${headerText}`}</title>
				<link rel="stylesheet" href="https://bellwork-cg1.firebaseapp.com/img/main.css" type="text/css" />
				<link href="https://fonts.googleapis.com/css?family=Bitter|Open+Sans:400,700" rel="stylesheet" />
				<link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.0.10/css/all.css" integrity="sha384-+d0P83n9kaQMCwj8F4RJB66tzIwOKmrdb46+porD/OvrJ+37WqIM7UoBtwHO6Nlg"
      crossOrigin="anonymous" />   
			</head>



			<body>
				<footer>
					<img src="https://bellwork-cg1.firebaseapp.com/img/masteryprep-logo.svg" alt="MasteryPrep Logo" />
				</footer>
				<OverviewPage 
					byTest={byTest}
					bySubtest={bySubtest}
					byNode={byNode}
					nodes={nodes}
					assessmentSubtests={userAssessment.assessmentSubtests}
					headerText={headerText}
					testTakingData={testTakingData}
					isGroup={isGroup}
				/>
				{skillBreakdownReports}
				{isGroup && 
					<TestTakingPage
						score={score}
						assessmentSubtests={userAssessment.assessmentSubtests}
						headerText={headerText}
						userAssessment={userAssessment}
						studentScoring={studentScoring}
						testTakingData={testTakingData}
					/>
				}
				{isGroup && 
					<ThresholdPage
						threshold={thresholdData}
						thresholdBreaks={thresholdBreaks}
						headerText={headerText}
					/>
				}
				{
					isGroup
					? <AnswerPercentagePages
							isGroup={isGroup}
							assessmentSubtests={userAssessment.assessmentSubtests}
							items={items}
							nodes={nodes}
							answersByItem={userAssessment.answersByItem}
							destructuredSubtests={userAssessment.destructuredSubtests}
							headerText={headerText}
						/>
					: null
				}
				{
					isGroup
					? <ScoresByStudentPage
							studentScoring={studentScoring}
							subtests={userAssessment.assessmentSubtests}
							headerText={headerText}
						/>
					: null
				}
				{isGroup && printStudentReports &&
					 studentScores.map((studentScore) => 
							<StudentReportPage
								studentScore={studentScore}
								subtests={userAssessment.assessmentSubtests}
								nodes={nodes}
								key={`StuRepPg${studentScore.userId}`}
								headerText={headerText}
							/>
				)}
				{
					isGroup
					? <StudentAnswerMapPages 
							subtests={userAssessment.assessmentSubtests}
							studentScores={studentScores}
							answers={studentScores[0].answers}
							headerText={headerText}
						/>
					: null
				}
			</body>
		</html>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/AssessPrintTemplate.js